import React, { memo, useMemo } from 'react';
import { createUseStyles, Text, Advice } from '@Sage/hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'StepHeader');
const StepHeader = _ref => {
  let {
    title,
    subtitle,
    errors,
    children = null
  } = _ref;
  const classes = useStyles();
  const getErrors = useMemo(() => {
    if (!(errors !== null && errors !== void 0 && errors.length)) return null;
    return errors.map((error, index) => /*#__PURE__*/React.createElement(Advice, {
      key: index,
      className: classes.error,
      type: "error"
    }, error));
  }, [classes.error, errors]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.stepHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.stepHeaderContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerContent
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    size: "large"
  }, title), /*#__PURE__*/React.createElement(Text, {
    className: classes.stepSubtitle
  }, subtitle)), children), getErrors);
};
process.env.NODE_ENV !== "production" ? StepHeader.propTypes = {} : void 0;
export default /*#__PURE__*/memo(StepHeader);